import NodeDefinitionClassDico from './node-definition-class-dico';
import NodeDefinitionClassCommon from './node-definition-class-common';

export default class NodeDefinitionClass {
	/**
	 * @param {any} [c]
	 */
	constructor(c = null) {
		this.MODE = c?.MODE ?? 'NORMAL';

		/** @type {Record<string, NodeDefinitionClassDico>} */
		this.DICO = {};
		if (c?.DICO) {
			for (const [key, dico] of Object.entries(c.DICO)) {
				this.DICO[key] = new NodeDefinitionClassDico(dico)
			}
		}

		this.COMMON = c?.COMMON ? c.COMMON.map((/** @type {any} */ common) => new NodeDefinitionClassCommon(common)) : [];
		this.DEFAULT_VALUE = c?.DEFAULT_VALUE ?? {};
		this.RESTRICTED_VALUE = c?.RESTRICTED_VALUE ?? {};
		this.RULES = c?.RULES ?? {};
		this.KEY = c?.KEY ?? null;
	}
}